module.exports = __webpack_public_path__ + "static/media/walmart.71e93da6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/client_logos/walmart.png
// module id = 294
// module chunks = 0